import BaseTibbit from '@appblocks/codegeneration/Tibbits/_BaseTibbit';
import Tibbits from '@appblocks/codegeneration/Tibbits/index';
import {
    CodeBlock, BlockType, SettingType, SettingState, TibboDataType, IOMode,
} from '@appblocks/codegeneration/types';
import IOTibbit from '@appblocks/codegeneration/Tibbits/_IOTibbit';

export default class Tibbit_11 extends IOTibbit {
    constructor() {
        super();
        this.id = 'tibbit_11';
        this.name = 'Tibbit 11';
        this.lines = 4;
        this.mode = IOMode.OUTPUT;
        this.initLines();
    }
}
